import { render, staticRenderFns } from "./worklist_control_bar.vue?vue&type=template&id=3b542563&scoped=true"
import script from "./worklist_control_bar.vue?vue&type=script&lang=js"
export * from "./worklist_control_bar.vue?vue&type=script&lang=js"
import style0 from "./worklist_control_bar.vue?vue&type=style&index=0&id=3b542563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b542563",
  null
  
)

export default component.exports